import { render, staticRenderFns } from "./canteenuser.vue?vue&type=template&id=b038d810&"
import script from "./canteenuser.vue?vue&type=script&lang=js&"
export * from "./canteenuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports